export default __webpack_public_path__ + "static/media/wrong.953f7c45.svg";